import { ThemeConsumer } from '@rneui/themed'
import React, { Dispatch, FC, SetStateAction, useCallback } from 'react'
import { StyleSheet, useWindowDimensions, View } from 'react-native'
import { Camera, Code, useCameraDevice, useCodeScanner } from 'react-native-vision-camera'

export const MobileBarcodeScanner: FC<{
	setScannerVisibleModal: Dispatch<SetStateAction<boolean>>
	setScannerValue: Dispatch<SetStateAction<any>>
}> = ({
	setScannerVisibleModal,
	setScannerValue
}) => {
		const device = useCameraDevice('back')
		const { width } = useWindowDimensions()

		const onCodeScanned = useCallback((codes: Code[]) => {
			const value = codes[0]?.value
			if (value == null) return
			else {
				setScannerValue(value)
				setScannerVisibleModal(false)
			}
		}, [])
		const codeScanner = useCodeScanner({
			codeTypes: ['qr', 'ean-13', 'data-matrix'],
			onCodeScanned: onCodeScanned,
		})
		return (
			<ThemeConsumer>
				{({ theme }) => (
					<View style={{ flex: 1 }}>
						{device != null &&
							<Camera
								style={StyleSheet.absoluteFill}
								device={device}
								codeScanner={codeScanner}
								isActive={true}
								enableZoomGesture={true}
								resizeMode={"contain"}
							/>
						}
					</View>
				)}
			</ThemeConsumer>
		)
	}
